import { render } from "./NewFeeSchedule.vue?vue&type=template&id=2af7e2fd"
import script from "./NewFeeSchedule.vue?vue&type=script&lang=js"
export * from "./NewFeeSchedule.vue?vue&type=script&lang=js"

import "./NewFeeSchedule.vue?vue&type=style&index=0&id=2af7e2fd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__